import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=8aa0f2f2&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=8aa0f2f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa0f2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aa0f2f2')) {
      api.createRecord('8aa0f2f2', component.options)
    } else {
      api.reload('8aa0f2f2', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=8aa0f2f2&scoped=true", function () {
      api.rerender('8aa0f2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/staffManage/transfer.vue"
export default component.exports